module.exports = __webpack_public_path__ + "static/media/P11.11814b97.jpg";